import {
  CompanyTransportServicesReportFormDefaultValues,
  CompanyTransportServicesReportFormProps,
  CompanyTransportServicesReportFormRawValues,
  CompanyTransportServicesReportFormType
} from "./CompanyTransportServicesReportForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {getObjectId, startOfDay, subDays} from "@ots-frontend/ots-data";

const getInitialValues = (defaultValues: CompanyTransportServicesReportFormDefaultValues | undefined): CompanyTransportServicesReportFormRawValues => {
  return {
    category: defaultValues?.category?.code,
    fromDate: defaultValues?.fromDate,
    toDate: defaultValues?.toDate,
    reportTimeBasis: defaultValues?.reportTimeBasis,
    operators: defaultValues?.operators?.map(getObjectId),
    drivers: defaultValues?.drivers?.map(getObjectId),
  }
}

export type UseCompanyTransportServicesReportFormProps =
  Pick<CompanyTransportServicesReportFormProps, 'defaultValues'>
  & {}

export function useCompanyTransportServicesReportForm(props: UseCompanyTransportServicesReportFormProps): CompanyTransportServicesReportFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
      fromDate: defaultValues?.fromDate ?? startOfDay(subDays(new Date(), 1)),
      reportTimeBasis: defaultValues?.reportTimeBasis ?? "transport",
    }),
    validate: {
      fromDate: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
